module.exports = __webpack_public_path__ + "static/furniture-daily-deals-section-eba122208a0cae20b13bc1823c34e6d8.png";